import axios from 'axios';
import { API_BASE_URL } from '@/config';

export class AudienceApi {
  static getAudiences = async () => {
    return (await axios.get(`${API_BASE_URL}/audiences`)).data;
  };

  static getAudience = async (id) => {
    return (await axios.get(`${API_BASE_URL}/audiences/${id}`)).data;
  };

  static createAudience = (formData) => {
    return axios.get(`${API_BASE_URL}/audiences`, formData);
  };

  static updateAudience = (id, formData) => {
    return axios.put(`${API_BASE_URL}/audiences/${id}`, formData);
  };

  static updateAudienceTemplates = (id, templates) => {
    return axios.put(`${API_BASE_URL}/audiences/${id}/templates`, templates);
  };

  static toggleAudienceDisabled = (id) => {
    return axios.patch(`${API_BASE_URL}/audiences/${id}/toggle-disabled`);
  };

  static getAudiencesForForm = async (isAdmin, organizationId = null) => {
    let url = `${API_BASE_URL}/audiences/for-form${
      isAdmin ? '?organizationId=' + organizationId : ''
    }`;
    return axios.get(url);
  };
}
